(function () {
  function initEmbers(container) {
    if (!container || container.dataset.ysInit) return;
    container.dataset.ysInit = 'true';
    var count = 26;
    for (var i = 0; i < count; i++) {
      var e = document.createElement('div');
      e.className = 'ys-ember';
      var left = Math.random() * 100;
      var duration = 6 + Math.random() * 8;
      var delay = Math.random() * 10;
      var size = 2 + Math.random() * 2.5;
      e.style.left = left + '%';
      e.style.width = size + 'px';
      e.style.height = size + 'px';
      e.style.animationDuration = duration + 's';
      e.style.animationDelay = delay + 's';
      container.appendChild(e);
    }
  }

  function initAll() {
    var containers = document.querySelectorAll('[data-ys-embers]');
    containers.forEach(initEmbers);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
